/**
 * Created by Florin David on 16/06/2017.
 */
import { combineReducers } from 'redux'

import updateInProgress from './updateInProgress'
import updateReady from './updateReady'

export default combineReducers({
  updateInProgress,
  updateReady,
})
